
/**
 * Dashboard Sidebar menu items and their respective properties
 * */
export const DashboardSidebarMenuItems = [
    {
        id: "SidebarMenuItem-1",
        name: "Dashboard",
        link: "/dashboard",
        iconClass: "glyphicon glyphicon-dashboard",
    },
    {
        id: "SidebarMenuItem-2",
        name: "Reports",
        link: "/reports",
        iconClass: "glyphicon glyphicon-stats",
    },
    {
        id: "SidebarMenuItem-3",
        name: "File Submissions",
        link: "/submissions",
        iconClass: "glyphicon glyphicon-open-file",
    },
    {
        id: "SidebarMenuItem-4",
        name: "Benchmarking",
        link: "/benchmarking",
        iconClass: "glyphicon glyphicon-glass",
    },
    {
        id: "SidebarMenuItem-5",
        name: "Reference Documents",
        link: "/downloads",
        iconClass: "glyphicon glyphicon-list",
    },
    {
        id: "SidebarMenuItem-6",
        name: "User Management",
        link: "/manageusers",
        iconClass: "glyphicon glyphicon-user",
    },
    {
        id: "SidebarMenuItem-7",
        name: "Help & Support",
        link: "/help",
        iconClass: "glyphicon glyphicon-earphone",
    },
    {
        id: "SidebarMenuItem-8",
        name: "Sign Out",
        link: "/Logout",
        iconClass: "glyphicon glyphicon-hand-left",
    },
];